import { IDM_API_URLS } from "../../constants/constants";
import { getInterventionsAirbrake } from "../../utils/getInterventionsAirbrake";
import type { InterventionsResponse } from "./InterventionsProvider";

const options = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

type FetchInterventionsProps = {
  duid: string;
  site: string;
  vertical?: string;
  apiUrl?: string;
} & Record<string, unknown>;

const baseUrl = IDM_API_URLS();

const airbrake = getInterventionsAirbrake();

// TODO: Add airbrakes on fail
export const fetchInterventions = async ({
  duid,
  site,
  vertical,
  apiUrl,
  ...extraData
}: FetchInterventionsProps) => {
  try {
    const response = await fetch(`${apiUrl ?? baseUrl}/interventions`, {
      ...options,
      body: JSON.stringify({
        system_user_id: duid,
        site,
        vertical,
        ...extraData,
      }),
    });
    const data = (await response.json()) as InterventionsResponse;

    return data;
  } catch (error) {
    if (process.env.NODE_ENV !== "test") {
      airbrake.notify(error);
    }
    throw error;
  }
};

type SetInterventionShownProps = FetchInterventionsProps & {
  interventionName: string;
};

export const setInterventionShown = async ({
  duid,
  interventionName,
  apiUrl,
  site,
  vertical,
}: SetInterventionShownProps) => {
  try {
    const response = await fetch(`${apiUrl ?? baseUrl}/intervention/shown`, {
      ...options,
      body: JSON.stringify({
        system_user_id: duid,
        site,
        vertical,
        intervention_name: interventionName,
      }),
    });
    const result = (await response.json()) as boolean;

    return result;
  } catch (error) {
    airbrake.notify(error);
    return false;
  }
};
